import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VerificationTestdafFormComponent } from './verification-testdaf-form/verification-testdaf-form.component';
import { VerificationTestdafDigitalComponent } from './verification-testdaf-digital/verification-testdaf-digital.component';
import { VerificationComponent } from './verification/verification.component';
import { VerificationTestasFormComponent } from './verification-testas-form/verification-testas-form.component';
import { VerificationDmatFormComponent } from './verification-dmat-form/verification-dmat-form.component';
import { VerificationDtzFormComponent } from './verification-dtz-form/verification-dtz-form.component';
import { VerificationDtzChoiceComponent } from './verification-dtz-choice/verification-dtz-choice.component';
import { VerificationDtzQrCodeComponent } from './verification-dtz-qr-code/verification-dtz-qr-code.component';
import { VerificationDtzPdfFormComponent } from './verification-dtz-pdf-form/verification-dtz-pdf-form.component';
import { VerificationBestOfCertificateTestdafComponent } from './verification-best-of-certificate-testdaf/verification-best-of-certificate-testdaf.component';

const routes: Routes = [
  { path: 'verification', component: VerificationComponent },
  { path: 'verification-testdaf-digital', component: VerificationTestdafDigitalComponent },
  { path: 'verification-testdaf-form', component: VerificationTestdafFormComponent },
  { path: 'verification-testas-form', component: VerificationTestasFormComponent },
  { path: 'verification-dmat-form', component: VerificationDmatFormComponent },
  { path: 'verification-dtz', component: VerificationDtzChoiceComponent },
  { path: 'verification-dtz-choice', component: VerificationDtzChoiceComponent },
  { path: 'verification-dtz-form', component: VerificationDtzFormComponent },
  { path: 'verification-dtz-qr-code', component: VerificationDtzQrCodeComponent },
  { path: 'verification-dtz-pdf-form', component: VerificationDtzPdfFormComponent },
  { path: 'verification-combined-testdaf', component: VerificationBestOfCertificateTestdafComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
